import { styled } from "@woba/ds-web";

export const Wrapper = styled("div", {
  display: "flex",
  gap: "$space-03",

  "@sm": {
    flexDirection: "column",
    width: "100%",
  },
});
